export default abstract class StaticData {
	static items: any[] = []

	static remove(index: number) {
		this.items.splice(index, 1)
	}

	static reset() {
		this.items = []
	}
}
